import React, { Component, createRef } from "react";
import {
  BASE_URL,
  bpReadingCommunicationLog,
  RPM_CONNECTIVITY_SIGNAL_STRENGTH_THRESHOLD,
} from "../../../static/constants";
import getToken from "../../../utils/getToken";

import TextField from "@mui/material/TextField";
import Fab from "@mui/material/Fab";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";

import "./index.css";
import { withStyles } from "@mui/styles";
import Switch from "@mui/material/Switch";
import LoadingSpinner from "../../../components/LoadingSpinner";
// import Chart from '../Chart';
import Chart from "../Chart/v2";
import Notes from "./Notes";

import cloneDeep from "lodash/cloneDeep";
import Tooltip from "@mui/material/Tooltip";
import PatientEnrollModal from "components/common/modals/patientEnrollModal/PatientEnrollModal";
import { connect } from "react-redux";
import {
  changePatient,
  toggleDeactivate,
  toggleModal,
} from "app/store/transmission/slice/transmissionSlice";
import PatientModal from "components/pages/transmissions/modal/patient/PatientModal";
import RpmTableToolbar from "./toolbar/RpmTableToolbar";

import formatDate from "utils/formatDate";
import {
  Error as ErrorIcon,
  Visibility as VisibilityIcon,
  Description as DescriptionIcon,
  CheckCircle as CheckCircleIcon,
  Preview,
} from "@mui/icons-material";
import {
  onBPReadingView,
  onRPMRowChange,
  togglePatientRPMModal,
} from "app/store/patient/slice/patientSlice";
import CommunicationLogModal from "../CommunicationLogModal/CommunicationLogModal";
import {
  downloadRpmCoverPage,
  fetchRpmPatientBilling,
} from "../../../services/rpmCoverPage.service";
import { showErrorToast, showSuccessToast } from "utils/toast";
import LoadingModal from "components/common/loading/LoadingModal";
import { downloadFile } from "app/utils/file";
import ReportTypeModal from "../ReportTypeModal/ReportTypeModal";
import { enrollPatient } from "app/services/patient/patient";
import { formatDateTime, getFormattedDate } from "utils/date";
import { updateBPChartViewStatus } from "app/services/patient/rpmPatient";
import { Chip, FormControlLabel, Grid } from "@mui/material";
import ScaleChart from "components/pages/rpm/chart/ScaleChart";
import { EVOKE_BP_CUFF, EVOKE_SCALE } from "static/manufacturers";
import CustomTable from "components/common/table/CustomTable";
import { DATE_FORMAT } from "static/date";
import ReportPreviewModal from "../ReportPreviewModal/ReportPreviewModal";
import ConfirmModal from "components/common/modals/confirmModal/ConfirmModal";
import {
  setIsTransferredFromRpm,
  setRpmPatientBilling,
  setRpmReport,
  setRpmReportFile,
  setRpmReportUrl,
  setSelectedRpmPatient,
} from "app/store/rpmPatients/slice/rpmPatientsSlice";
import { isValidArray } from "utils/array";
import { dateFilter, textFilter } from "utils/table";
import { setIsExistingPatient } from "app/store/manualUpload/slice/manualUploadSlice";

const CustomSwitch = withStyles({
  switchBase: {
    color: "#FFFFFF !important",
    "&$checked": {
      color: "#94ba33 !important",
    },
    "&$checked + $track": {
      backgroundColor: "#000000",
      opacity: ".38 !important",
    },
  },
  checked: {},
  track: {
    backgroundColor: "#000000",
    opacity: ".38 !important",
  },
})(Switch);

class Table extends Component {
  constructor(props) {
    super(props);
    const { changeRpmProps, changeFilter } = this.props;

    this.state = {
      renderChart: true,
      showNotes: false,
      switchLoading: false,
      filterActive: true,
      nameValue: "",
      // isFilters: false,
      selectedPatient: {
        id: "",
        name: "",
        email: "",
        password: "",
        passwordConfirm: "",
        role: "",
        accounts: [],
        accountArr: [],
        manufacturer: [],
        manufacturerArr: [],
      },
      patientData: this.props.patientProps.patientData,
      PatientModalOpen: false,
      requestType: "PUT",
      PatientModalHeader: "Patient Information",
      modalType: "add",
      columnData: [
        {
          header: "Name",
          accessorKey: "name",
          filterVariant: "text",
          filterFn: textFilter,
        },
        {
          header: "Date of Birth",
          accessorKey: "dateOfBirth",
          filterVariant: "date",
          filterFn: dateFilter,
          Cell: ({ row }) =>
            getFormattedDate(row?.original?.dateOfBirth, DATE_FORMAT.DEFAULT),
        },
        {
          header: "Manufacturer",
          accessorKey: "manufacturer",
          filterVariant: "text",
          filterFn: textFilter,
          Cell: ({ row }) => {
            const rowData = row?.original;

            return (
              <Grid container direction="column" spacing={1}>
                {rowData?.manufacturer?.map((manufacturer, index) => (
                  <Grid item key={index}>
                    <Chip label={manufacturer} variant="outlined" />
                  </Grid>
                ))}
              </Grid>
            );
          },
        },
        {
          header: "Account",
          accessorKey: "account",
          filterVariant: "text",
          filterFn: textFilter,
        },
        {
          header: "Last Transmission",
          accessorKey: "lastTransmittedDate",
          filterVariant: "date",
          filterFn: dateFilter,
          Cell: ({ row }) => {
            const rowData = row?.original;
            const scheduled = rowData.scheduled;

            if (rowData) {
              if (scheduled === true) {
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <Tooltip title="Transmission on schedule">
                      <CheckCircleIcon className="completed" />
                    </Tooltip>

                    <Tooltip title="Transmission on schedule">
                      <span style={{ fontSize: "14px", fontWeight: "400" }}>
                        {getFormattedDate(
                          rowData.lastTransmittedDate,
                          DATE_FORMAT.DEFAULT
                        )}
                      </span>
                    </Tooltip>
                  </div>
                );
              } else if (scheduled === false) {
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <Tooltip title="Late Transmission">
                      <ErrorIcon className="error" />
                    </Tooltip>
                    <Tooltip title="Late Transmission">
                      <span style={{ fontSize: "14px", fontWeight: "400" }}>
                        {formatDate(rowData.lastTransmittedDate, "MM/DD/YYYY")}
                      </span>
                    </Tooltip>
                  </div>
                );
              } else {
                return;
              }
            }
          },
        },

        {
          header: "Active",
          accessorKey: "active",
          filterVariant: "checkbox",
          enableColumnFilter: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          Cell: ({ row }) => {
            const rowData = row?.original;

            const { dispatch } = this.props;

            return (
              <FormControlLabel
                onClick={(e) => {
                  e.stopPropagation();
                  const isActive = e.target.checked;

                  if (!isActive) {
                    dispatch(
                      toggleDeactivate({
                        deactivateFrom: "table",
                        isDeactivate: !isActive,
                      })
                    );
                    dispatch(
                      changePatient({
                        patientId: rowData?.id,
                        account: rowData?.account,
                        serialNumber: rowData?.serialNumber,
                      })
                    );
                  } else {
                    this.handleSwitchChange(e, rowData.serialNumber);
                  }
                }}
                disabled={this.state.switchLoading}
                control={<CustomSwitch defaultChecked={rowData.active} />}
              />
            );
          },
        },
        {
          header: "Actions",
          accessorKey: "actions",
          filterVariant: "text",
          enableColumnFilter: false,
          enableSorting: false,
          accessorFn: (rowData) => {
            const { role } = this.props;
            const loggedUserId = localStorage.getItem("userId");

            const {
              bpReadingViewedByMe,
              firstBPReadingHistory: { readingDate, viewer, bpDate } = {},
            } = rowData || {};

            return (
              <div className="rpm-action-buttons-group">
                {role !== "clinic" && (
                  <Tooltip title={"Communication Logs"}>
                    <DescriptionIcon
                      className="rpm-action-button"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        const { tableData, ...rest } = rowData;
                        const { dispatch } = this.props;

                        dispatch(
                          togglePatientRPMModal({
                            type: "communicationLog",
                            value: { open: true, action: "", data: rest },
                          })
                        );

                        dispatch(onRPMRowChange(rest));
                      }}
                    />
                  </Tooltip>
                )}

                <Tooltip title={"Preview Report"}>
                  <Preview
                    className="rpm-action-button ml-2"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.handlePreviewReportClick(rowData);
                    }}
                  />
                </Tooltip>

                <Tooltip
                  title={
                    viewer?.name ? (
                      <div className="d-flex flex-column">
                        <div className="mb-2">
                          {`Viewed by ${
                            viewer?._id === loggedUserId ? "you" : viewer?.name
                          } at ${formatDateTime(
                            readingDate,
                            "MM/DD/YYYY hh:mm:ss A"
                          )}.`}
                        </div>
                        <div>
                          {bpReadingViewedByMe?.status
                            ? "Click to set as un-viewed."
                            : "Click to set as viewed."}
                        </div>
                      </div>
                    ) : bpDate ? (
                      <div>
                        {bpReadingViewedByMe?.status
                          ? "Click to set as un-viewed."
                          : "Click to set as viewed."}
                      </div>
                    ) : (
                      <></>
                    )
                  }
                >
                  <VisibilityIcon
                    className="rpm-action-button ml-2"
                    style={{
                      color: bpReadingViewedByMe?.status
                        ? "#94BA33"
                        : viewer?._id !== loggedUserId && viewer?.name
                          ? "orange"
                          : "grey",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();

                      const dataCopy = cloneDeep(this.state.patientData);
                      const patientToUpdate = dataCopy.find(
                        ({ id }) => id === rowData.id
                      );

                      let lastBPDate = rowData?.lastTransmittedDate;
                      if (!lastBPDate) {
                        const scaleReadings =
                          this.props.patientProps?.patient?.scaleChartData;
                        const scaleReadingLabels = scaleReadings?.labels ?? [];
                        lastBPDate =
                          scaleReadingLabels?.[scaleReadingLabels?.length - 1];
                      }

                      if (bpDate) {
                        this.handleUpdateBpChartView(
                          { ...rowData, lastTransmittedDate: lastBPDate },
                          !patientToUpdate?.bpReadingViewedByMe?.status,
                          true
                        );
                      }
                    }}
                  />
                </Tooltip>
              </div>
            );
          },
        },
      ],
      tableComponents: {
        Toolbar: (props) => (
          <RpmTableToolbar
            {...props}
            changeSchedule={changeRpmProps}
            changeRpmFilter={changeFilter}
          />
        ),
        FilterRow: (props) => {
          return (
            <tr className="trans-table__filterRow">
              <td colSpan={1}></td>
              <td>
                <div style={{ margin: "10px 0", padding: "0 10px 0px" }}>
                  <TextField
                    className="filter_input"
                    onChange={(event) => {
                      props.onFilterChanged(0, event.target.value);
                    }}
                  />
                </div>
              </td>
              <td>
                <div style={{ margin: "10px 0", padding: "0 10px 0px" }}>
                  <TextField
                    className="filter_input"
                    onChange={(event) => {
                      props.onFilterChanged(1, event.target.value);
                    }}
                  />
                </div>
              </td>
              <td>
                <div style={{ margin: "10px 0", padding: "0 10px 0px" }}>
                  <TextField
                    className="filter_input"
                    onChange={(event) => {
                      props.onFilterChanged(2, event.target.value);
                    }}
                  />
                </div>
              </td>
              <td>
                <div style={{ margin: "10px 0", padding: "0 10px 0px" }}>
                  <TextField
                    className="filter_input"
                    onChange={(event) => {
                      props.onFilterChanged(3, event.target.value);
                    }}
                  />
                </div>
              </td>
              <td>
                <div style={{ margin: "10px 0", padding: "0 10px 0px" }}>
                  <TextField
                    className="filter_input"
                    onChange={(event) => {
                      props.onFilterChanged(4, event.target.value);
                    }}
                  />
                </div>
              </td>
              <td></td>
            </tr>
          );
        },
      },
      PatientEnrollModalOpen: false,
      isDownloading: false,
      showReportTypeModal: false,
      showReportPreviewModal: false,
      generateReportProps: {},
      report: null,
      reportFile: null,
      reportFileUrl: null,
      isGeneratingReport: false,
      showSendReportToTransmissionConfirmation: false,
      isRedirectingToManualUpload: false,
    };

    this.tableRef = createRef();

    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.closePatientModal = this.closePatientModal.bind(this);
    this.saveUser = this.saveUser.bind(this);
    this.handleFilterUpdate = this.handleFilterUpdate.bind(this);
    this.openEnrollModal = this.openEnrollModal.bind(this);
    this.closeEnrollModal = this.closeEnrollModal.bind(this);
    this.handleSwitchChange = this.handleSwitchChange.bind(this);
    this.updatePatientData = this.updatePatientData.bind(this);
    this.toggleNotes = this.toggleNotes.bind(this);
    this.handleUpdateBpChartView = this.handleUpdateBpChartView.bind(this);
  }

  updateDownloadStatus = (status) => {
    this.setState({
      isDownloading: status,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.patientProps.patientData !== this.props.patientProps.patientData
    ) {
      this.setState({
        patientData: this.props.patientProps.patientData,
      });
    }
  }

  handleSwitchChange(e, serialNumber) {
    this.setState({
      switchLoading: true,
    });
    const active = e.target.checked;

    if (active) {
      this.props.enablePatientSubmit(serialNumber).then(() => {
        this.setState({
          switchLoading: false,
        });
      });
    } else {
      this.props.disablePatientSubmit(serialNumber).then(() => {
        this.setState({
          switchLoading: false,
        });
      });
    }
  }

  toggleNotes() {
    this.setState(
      {
        renderChart: false,
        showNotes: !this.state.showNotes,
      },
      () => {
        this.setState({
          renderChart: true,
        });
      }
    );
  }

  handleEdit(rowData) {
    const selectedPatient = Object.assign({}, rowData);
    const { dispatch } = this.props;

    dispatch(
      changePatient({
        patientId: rowData?.id,
        serialNumber: rowData?.serialNumber,
        account: rowData?.account,
      })
    );

    dispatch(toggleModal({ type: "patient", value: true }));

    this.setState({
      selectedPatient,
      PatientModalOpen: true,
      requestType: "PUT",
      modalType: "edit",
    });
  }

  handleAdd() {
    this.setState({
      PatientModalOpen: true,
      requestType: "POST",
      PatientModalHeader: "Add New User",
      modalType: "add",
      selectedPatient: {
        name: "",
        email: "",
        password: "",
        passwordConfirm: "",
        role: "",
        accounts: [],
        accountArr: [],
        manufacturer: [],
        manufacturerArr: [],
      },
    });
  }

  handleUpdate(val, key) {
    const { selectedPatient } = this.state;
    selectedPatient[key] = val;

    this.setState({
      selectedPatient,
    });
  }

  handleFilterUpdate(e, key) {
    const els = document.querySelectorAll(".filter_input input");
    let isFitered = false;
    els.forEach((el) => {
      if (el.value.length) {
        isFitered = true;
      }
    });

    const table = document.getElementById("patientTable");

    if (isFitered) {
      table.classList.add("showResults");
    } else {
      table.classList.remove("showResults");
    }
  }

  closePatientModal() {
    this.setState({
      PatientModalOpen: false,
    });
  }

  openEnrollModal() {
    this.setState({
      PatientEnrollModalOpen: true,
    });
  }

  closeEnrollModal() {
    this.setState({
      PatientEnrollModalOpen: false,
    });
  }

  saveUser() {
    const { selectedPatient, requestType } = this.state;
    const { getPatients } = this.props;
    const accounts = selectedPatient.accountArr;
    const manufacturer = selectedPatient.manufacturerArr;
    // selectedPatient.accounts = accounts;
    const payload = {
      _id: selectedPatient.id,
      name: selectedPatient.name,
      prevName: selectedPatient.prevName,
      role: selectedPatient.role,
      accounts,
      manufacturer,
      password: selectedPatient.password,
      email: selectedPatient.email,
    };

    // return false;
    fetch(`${BASE_URL}/admin/user`, {
      method: requestType,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.message) {
          if (
            data.message === "user successfully updated" ||
            data.message === "user successfully created"
          ) {
            this.setState(
              {
                PatientModalOpen: false,
              },
              () => {
                getPatients();
              }
            );
          } else {
            throw Error(data.message);
          }
        }
      })
      .catch((error) => {
        const errorStr = error.toString();
        if (errorStr === "Error: jwt malformed") {
          this.props.navigate("/login");
        }
        if (errorStr === "Error: jwt expired") {
          this.props.navigate("/login");
        }
        if (errorStr === "Error: Unauthorized") {
          this.props.navigate("/prohibited");
        }
      });
  }

  updatePatientData(newData) {
    const serialNumber = newData.patient;
    const dataCopy = cloneDeep(this.state.patientData);
    const selectedPatientCopy = cloneDeep(this.state.selectedPatient);

    let patientToUpdate = dataCopy.find((patient) => {
      return patient.serialNumber === serialNumber;
    });

    const middeInitialHtml = newData.middleInitial
      ? `, ${newData.middleInitial}`
      : "";

    patientToUpdate.dateOfBirth = newData.dob || patientToUpdate.dateOfBirth;
    patientToUpdate.device = newData.device || patientToUpdate.device;
    patientToUpdate.name = `${newData.lastName}, ${newData.firstName}${middeInitialHtml}`;

    selectedPatientCopy.dateOfBirth =
      newData.dob || patientToUpdate.dateOfBirth;
    selectedPatientCopy.device = newData.device || patientToUpdate.device;
    selectedPatientCopy.name = `${newData.lastName}, ${newData.firstName}${middeInitialHtml}`;

    this.setState({
      patientData: dataCopy,
      selectedPatient: selectedPatientCopy,
    });
  }

  updateReportTypeModalStatus = (status) => {
    this.setState({
      showReportTypeModal: status,
    });
  };

  updateReportPreviewModalStatus = (status) => {
    this.setState({
      showReportPreviewModal: status,
    });
  };

  handlePreviewReportClick = async (rowData) => {
    const selectedPatientCopy = {
      ...this.state.selectedPatient,
      ...rowData,
    };
    this.setState({ selectedPatient: selectedPatientCopy });
    this.updateReportTypeModalStatus(true);
  };

  handleReportDownload = async () => {
    try {
      this.updateDownloadStatus(true);
      const { report } = this.state;
      downloadFile(report);
    } catch (error) {
      showErrorToast(error?.message);
    } finally {
      this.updateReportTypeModalStatus(false);
      this.updateDownloadStatus(false);
    }
  };

  generateReport = async ({
    billingCodes = [],
    reportOf31DayWithAlert = false,
  }) => {
    const { id: patientId } = this.state.selectedPatient;
    const payload = {
      billingCodes,
      isBack31Days: billingCodes.length > 0,
      reportOf31DayWithAlert,
    };

    this.setState({ isGeneratingReport: true });

    try {
      const response = await downloadRpmCoverPage(patientId, payload);
      await this.getRpmPatientBilling(patientId, payload);
      const reportBlob = new Blob([response.data]);
      const reportFileUrl = URL.createObjectURL(reportBlob);
      const reportFile = new File([reportBlob], "report.pdf", {
        type: "application/pdf",
      });

      this.setState({
        generateReportProps: { billingCodes, reportOf31DayWithAlert },
        report: response,
        reportFileUrl,
        reportFile,
      });

      this.updateReportPreviewModalStatus(true);
    } catch (error) {
      showErrorToast(error?.message || "Error generating report");
    } finally {
      this.setState({ isGeneratingReport: false });
    }
  };

  getRpmPatientBilling = async (patientId, payload) => {
    try {
      const { dispatch } = this.props;

      const rpmPatientBilling = await fetchRpmPatientBilling(
        patientId,
        payload
      );

      dispatch(setRpmPatientBilling(rpmPatientBilling?.data));
    } catch (error) {
      showErrorToast(error?.message || "Error generating report");
    }
  };

  handleSendReportToTransmission = async () => {
    const { dispatch } = this.props;

    const {
      report = null,
      reportFile = null,
      reportFileUrl = null,
      selectedPatient = null,
    } = this.state;

    dispatch(setRpmReport(report));
    dispatch(setRpmReportFile(reportFile));
    dispatch(setRpmReportUrl(reportFileUrl));
    dispatch(setSelectedRpmPatient(selectedPatient));

    this.setState({ showSendReportToTransmissionConfirmation: true });
  };

  handleSendReportToTransmissionConfirmation = async () => {
    const { dispatch, navigate } = this.props;
    dispatch(setIsTransferredFromRpm(true));
    dispatch(setIsExistingPatient(true));
    navigate("/upload");
  };

  handleUpdateBpChartView = async (
    rowData,
    viewStatus = true,
    isViewStatusChanged = false
  ) => {
    try {
      const { id: patientId, lastTransmittedDate } = rowData || {};

      let lastBPDate = lastTransmittedDate;
      if (!lastBPDate) {
        const scaleReadings = this.props.patientProps?.patient?.scaleChartData;
        const scaleReadingLabels = scaleReadings?.labels ?? [];
        lastBPDate = scaleReadingLabels?.[scaleReadingLabels?.length - 1];
      }

      const payload = {
        status: viewStatus,
        bpDate: lastBPDate,
        readingDate: getFormattedDate(new Date(), "MM/DD/YYYY hh:mm:ss A"),
      };

      const response = await updateBPChartViewStatus(patientId, payload);
      if (response?.type === "Success") {
        if (isViewStatusChanged) {
          showSuccessToast(`View status updated successfully`);
        }
        const dataCopy = cloneDeep(this.state.patientData);

        const patientToUpdateIndex = dataCopy.findIndex(
          (patient) => patient.id === patientId
        );
        if (patientToUpdateIndex !== -1) {
          const updatedPatient = {
            ...dataCopy[patientToUpdateIndex],
            ...response.data,
            bpReadingViewedByMe: response?.data?.bpReadingViewedByMe,
            firstBPReadingHistory: response?.data?.firstBPReadingHistory,
            lastSignalStrength: response?.data?.lastSignalStrength,
          };

          dataCopy[patientToUpdateIndex] = updatedPatient;

          this.setState({
            patientData: dataCopy,
          });
        }
      }
    } catch (error) {
      showErrorToast(error?.message);
    }
  };

  render() {
    const { PatientEnrollModalOpen, columnData } = this.state;
    const { patientProps, role, changeRpmProps, changeFilter, getPatients } =
      this.props;

    return (
      <div>
        {patientProps?.patient?.isCommunicationLogModal && (
          <CommunicationLogModal role={role} />
        )}
        <PatientModal />
        {PatientEnrollModalOpen && (
          <PatientEnrollModal
            modalOpen={PatientEnrollModalOpen}
            closeModal={this.closeEnrollModal}
            enrollPatientSubmit={enrollPatient}
            getPatients={getPatients}
            role={role}
          />
        )}
        {patientProps.userDataLoading && (
          <div style={{ padding: "50px 0", textAlign: "center" }}>
            <LoadingSpinner />
          </div>
        )}
        {!patientProps.userDataLoading && (
          <div>
            <div id="patientTable" className="trans-table__container">
              <CustomTable
                options={{
                  enableTopToolbar: true,
                  enableSorting: true,
                  rowsPerPageOptions: [25, 50, 100],
                  state: {
                    showGlobalFilter: true,
                    showColumnFilters: patientProps.isFilters,
                  },
                  renderTopToolbar: ({ table }) => (
                    <RpmTableToolbar
                      table={table}
                      openEnrollModal={this.openEnrollModal}
                      changeSchedule={changeRpmProps}
                      changeRpmFilter={changeFilter}
                    />
                  ),
                  muiTableBodyRowProps: ({ _isDetailPanel, row }) => {
                    const rowData = row?.original;

                    return {
                      onClick: () => {
                        this.handleEdit(row?.original);
                      },
                      sx: {
                        cursor: "pointer",
                        backgroundColor: !rowData?.lastSignalStrength
                          ? "#fff"
                          : rowData?.lastSignalStrength <
                              RPM_CONNECTIVITY_SIGNAL_STRENGTH_THRESHOLD
                            ? "rgba(239, 83, 80, 0.25)"
                            : "rgba(76, 175, 80, 0.25)",
                      },
                    };
                  },
                  muiExpandButtonProps: ({ row }) => ({
                    onClick: () => {
                      setTimeout(() => {
                        let rpmPatient = row?.original;

                        const bpReadingList =
                          this.props.patientProps?.patient?.bpReadingsList ??
                          [];

                        const scaleReadings =
                          this.props.patientProps?.patient?.scaleChartData;
                        const scaleReadingLabels = scaleReadings?.labels ?? [];
                        const scaleReadingData = scaleReadings?.data ?? [];

                        const bpReadingExist = bpReadingList?.some(
                          (bpReading) => bpReading?.patientId === rpmPatient?.id
                        );

                        if (!bpReadingExist || isValidArray(scaleReadingData)) {
                          const communicationLog = {
                            ...bpReadingCommunicationLog,
                            communicated_date: getFormattedDate(
                              new Date(),
                              "MM/DD/YYYY hh:mm:ss A"
                            ),
                          };
                          const updatedBPReadings = [
                            ...bpReadingList,
                            {
                              patientId: rpmPatient?.id,
                              communicationLog,
                            },
                          ];

                          this.props.dispatch(
                            onBPReadingView(updatedBPReadings)
                          );
                        }

                        const dataCopy = cloneDeep(this.state.patientData);
                        const expandedPatient = dataCopy.find(
                          ({ id }) => id === rpmPatient?.id
                        );

                        const isDetailPanelExpanded =
                          expandedPatient?.isDetailPanelExpanded || false;

                        expandedPatient.isDetailPanelExpanded =
                          !isDetailPanelExpanded;

                        this.setState({ patientData: dataCopy });

                        const lastTransmittedDate =
                          rpmPatient?.lastTransmittedDate ||
                          scaleReadingLabels?.[scaleReadingLabels?.length - 1];

                        if (
                          !!lastTransmittedDate &&
                          expandedPatient?.isDetailPanelExpanded
                        ) {
                          rpmPatient.lastTransmittedDate = lastTransmittedDate;
                          this.handleUpdateBpChartView(rpmPatient);
                        }
                      }, 100);
                    }, //set only this row to be expanded
                  }),
                  renderDetailPanel: ({ row }) => {
                    const rowData = row?.original;

                    const showScaleChart =
                      rowData.manufacturer.includes(EVOKE_SCALE);
                    const showBPChart =
                      rowData.manufacturer.includes(EVOKE_BP_CUFF);

                    return (
                      <div
                        style={{ display: "flex", minHeight: 400 }}
                        onClick={(event) => event.stopPropagation()}
                      >
                        <div style={{ flex: 4, position: "relative" }}>
                          <Fab
                            color="secondary"
                            aria-label="download"
                            onClick={this.toggleNotes}
                            style={{
                              position: "absolute",
                              top: 10,
                              right: 5,
                              zIndex: 999,
                              backgroundColor: "#ccc",
                              color: "#000",
                            }}
                          >
                            <Tooltip
                              title={
                                this.state.showNotes
                                  ? "Close Notes"
                                  : "Open Notes"
                              }
                              placement="bottom"
                            >
                              <SpeakerNotesIcon />
                            </Tooltip>
                          </Fab>
                          {this.state.renderChart && (
                            <>
                              {showBPChart && <Chart patientId={rowData.id} />}
                              {showScaleChart && (
                                <ScaleChart
                                  patientId={rowData.id}
                                  color="dark"
                                  height={70}
                                  isDetailPanel
                                />
                              )}
                            </>
                          )}
                        </div>
                        <div
                          style={{
                            width: 200,
                            flex: 2,
                            display: this.state.showNotes ? "block" : "none",
                          }}
                        >
                          <Notes />
                        </div>
                      </div>
                    );
                  },
                }}
                columns={columnData}
                data={this.state.patientData}
              />
              {/*<div style={{marginTop: '20px', textAlign: 'center', padding: '20px', fontSize: '14px'}} className="patient-table-instructions">*/}
              {/*  Type in filters to see matching results.*/}
              {/*</div>*/}
            </div>
          </div>
        )}

        {this.state.isDownloading && (
          <LoadingModal
            open={this.state.isDownloading}
            loadingText="Downloading..."
          />
        )}
        {this.state.showReportTypeModal && (
          <ReportTypeModal
            isModalOpen={this.state.showReportTypeModal}
            onClose={() => this.updateReportTypeModalStatus(false)}
            handleGenerateReport={this.generateReport}
          />
        )}
        {this.state.isGeneratingReport && <LoadingModal />}
        {this.state.showSendReportToTransmissionConfirmation && (
          <ConfirmModal
            confirmText="Proceed"
            title="Send report to transmission"
            show={this.state.showSendReportToTransmissionConfirmation}
            isConfirming={this.state.isRedirectingToManualUpload}
            onConfirm={this.handleSendReportToTransmissionConfirmation}
            onCancel={() =>
              this.setState({
                showSendReportToTransmissionConfirmation: false,
              })
            }
            children={
              <span>
                You will be redirected to the manual upload page to complete the
                report transmission. Would you like to proceed?
              </span>
            }
          />
        )}
        {this.state.showReportPreviewModal && (
          <ReportPreviewModal
            isModalOpen={this.state.showReportPreviewModal}
            onClose={() => this.updateReportPreviewModalStatus(false)}
            handleReportDownload={this.handleReportDownload}
            handleSendToTransmission={this.handleSendReportToTransmission}
            report={this.state.reportFileUrl}
          />
        )}
      </div>
    );
  }
}

export default connect()(Table);
